var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_1447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0302 2.69995C10.103 -0.230768 5.35436 -0.233682 2.4236 2.69341C-0.507126 5.62057 -0.510076 10.3693 2.41709 13.3001C5.34417 16.2308 10.0929 16.2337 13.0237 13.3066C15.9544 10.3795 15.9573 5.63068 13.0302 2.69995ZM8.77082 12.7591C8.77082 12.8748 8.67704 12.9685 8.56139 12.9685H6.88591C6.77025 12.9685 6.67647 12.8748 6.67647 12.7591V6.53932C6.67647 6.4236 6.77025 6.32989 6.88591 6.32989H8.56139C8.67704 6.32989 8.77082 6.42356 8.77082 6.53932V12.7591ZM7.72365 5.46071C7.0539 5.46071 6.50898 4.91586 6.50898 4.24608C6.50898 3.57637 7.05387 3.03141 7.72365 3.03141C8.39343 3.03141 8.93831 3.57633 8.93831 4.24608C8.93831 4.91586 8.39336 5.46071 7.72365 5.46071Z",
    fill: "#FCA34D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_1447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.223511 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.300cbbeaf313950df2630ef6d08a71db.svg";
export { ForwardRef as ReactComponent };